import { OnboardingBanner } from "@/components/dashboard/onboarding-banner";
import { SecurityOverview } from "@/components/dashboard/security-overview";

export default function DashboardPage() {
  return (
    <div className="space-y-6">
      <OnboardingBanner />
      <SecurityOverview />
    </div>
  );
}
